import ReducerType from "./ReducerType";

export default function combine(first: ReducerType, second: ReducerType) {
  return function combinedReducer(state: object, action: object) {
    const currentState = first(state, action);
    return second(currentState, action);
  };
}
